import axios from "axios";
import { fetchUserData } from "./usrinfo";

export const skillsAPI = async (query) => {
  try {
    let config = await fetchUserData();
    const response = await axios.get(
      `${process.env.REACT_APP_API_HOST}admin/matrix/skills?${query}`,
      config
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching skills matrix items:", error);
  }
};

export const locationsAPI = async (query) => {
  try {
    let config = await fetchUserData();
    const response = await axios.get(
      `${process.env.REACT_APP_API_HOST}admin/matrix/locations?${query}`,
      config
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching locations matrix items:", error);
  }
};

export const skillLocationAPI = async (data) => {
  try {
    let config = await fetchUserData();
    const response = await axios.post(
      `${process.env.REACT_APP_API_HOST}admin/user/skill-matrix-location`,
      data,
      config
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching locations matrix items:", error);
  }
};

export const exprienceAPI = async (query) => {
  try {
    let config = await fetchUserData();
    const response = await axios.get(
      `${process.env.REACT_APP_API_HOST}admin/matrix/experiences?${query}`,
      config
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching experiences matrix items:", error);
  }
};

export const identityAPI = async (query) => {
  try {
    let config = await fetchUserData();
    const response = await axios.get(
      `${process.env.REACT_APP_API_HOST}admin/matrix/identifies?${query}`,
      config
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching identifies matrix items:", error);
  }
};

export const reportingSkills = async (query) => {
  try {
    let config = await fetchUserData();
    const response = await axios.get(
      `${process.env.REACT_APP_API_HOST}admin/reporting/skills/tech?${query}`,
      config
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching identifies matrix items:", error);
  }
};

export const reportingNonTechSkills = async (query) => {
  try {
    let config = await fetchUserData();
    const response = await axios.get(
      `${process.env.REACT_APP_API_HOST}admin/reporting/skills/nontech?${query}`,
      config
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching identifies matrix items:", error);
  }
};

export const reportingLocations = async (query) => {
  try {
    let config = await fetchUserData();
    const response = await axios.get(
      `${process.env.REACT_APP_API_HOST}admin/reporting/locations?${query}`,
      config
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching identifies matrix items:", error);
  }
};

export const reportingExperiences = async (query) => {
  try {
    let config = await fetchUserData();
    const response = await axios.get(
      `${process.env.REACT_APP_API_HOST}admin/reporting/experiences?${query}`,
      config
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching identifies matrix items:", error);
  }
};

export const reportingIdentify = async (query) => {
  try {
    let config = await fetchUserData();
    const response = await axios.get(
      `${process.env.REACT_APP_API_HOST}admin/reporting/identify?${query}`,
      config
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching identifies matrix items:", error);
  }
};
